/*
 * 顺丰定制功能，在通用版的基础上，根据 80925 公司 ID 定制展示不同的菜单等功能
 */

export const shunfengCompanyId = 80925;

export function isShunfengCompany(companyId: number | string): boolean {
  return companyId == shunfengCompanyId;
}
